// Single source of truth for all projects.
// Used by the grid on index.html and the detail view on project.html.
const $8bc5ffe9ceba3d4c$export$8606c40cc696b7b = "https://github.com/Adityakapse";
const $8bc5ffe9ceba3d4c$export$39babdfab504f3da = [
    {
        id: "mathgpt",
        emoji: "\uD83E\uDDEE",
        name: "MathGPT",
        status: "done",
        short: "A GPT-style transformer built from scratch to solve nested arithmetic expressions. 93.21% accuracy on 7,700 equations.",
        tags: [
            "Python",
            "PyTorch",
            "Transformers",
            "NLP"
        ],
        body: [
            "MathGPT is a decoder-only transformer I built from scratch in PyTorch to evaluate complex arithmetic expressions with nested parentheses \u2014 a surprisingly hard sequence-to-sequence problem for language models.",
            "It reaches 93.21% accuracy across 7,700 held-out test equations. The key ideas were a custom number-aware tokenizer and an answer-reversal padding technique, which together lifted accuracy by 13% over naive character-level tokenization.",
            "Built as part of my Text Analytics module at Trinity College Dublin, alongside a companion BooleanGPT that solves boolean logic expressions."
        ],
        links: [
            {
                label: "View on GitHub",
                href: "https://github.com/Adityakapse/MathGpt-BooleanGpt",
                type: "github"
            }
        ],
        hidden: false
    },
    {
        id: "traffic",
        emoji: "\uD83D\uDEA6",
        name: "Globally Distributed Traffic System",
        status: "done",
        short: "A fault-tolerant, globally distributed traffic reservation system. 99.9% availability with zero message loss.",
        tags: [
            "Node.js",
            "Redis Streams",
            "Kafka",
            "AWS EKS"
        ],
        body: [
            "A globally distributed traffic-control system built as 7 cooperating microservices, designed for correctness under heavy concurrency and partial failure.",
            "I implemented pessimistic locking, idempotent event consumers and dead-letter queues over a Redis Streams pipeline to guarantee zero message loss during concurrent segment reservations.",
            "The services use the Transactional Outbox pattern with consumer-group load balancing, and database failover via CloudNativePG on AWS EKS \u2014 achieving 99.9% availability in testing. Built for my Distributed Systems module."
        ],
        links: [
            {
                label: "View on GitHub",
                href: "https://github.com/Adityakapse/traffic-service",
                type: "github"
            }
        ],
        hidden: false
    },
    {
        id: "searchengine",
        emoji: "\uD83D\uDD0E",
        name: "Full-Text Search Engine",
        status: "done",
        short: "A Java search engine on Apache Lucene over 500K+ TREC documents. Improved MAP by 38.6% over baseline.",
        tags: [
            "Java",
            "Apache Lucene",
            "Maven",
            "IR"
        ],
        body: [
            "A full-text search engine built on Apache Lucene with custom indexing over 500,000+ TREC-style documents.",
            "I compared 4 analyzers and 4 ranking models (BM25, VSM, LM-Dirichlet), achieving a best MAP of 0.4193 with the English analyzer and BM25.",
            "Layering Pseudo-Relevance Feedback and Reciprocal Rank Fusion across 5 query variants improved MAP by 38.6% over baseline, all evaluated automatically with trec_eval. Built for my Information Retrieval & Web Search module."
        ],
        links: [],
        hidden: false
    },
    {
        id: "disasters",
        emoji: "\uD83C\uDF06",
        name: "Response to City Disasters",
        status: "done",
        short: "A full-stack disaster-response platform with ML speech-to-text, severity prediction and evacuation routing.",
        tags: [
            "React",
            "Spring Boot",
            "AWS",
            "PostgreSQL"
        ],
        body: [
            "A full-stack disaster-response platform built with a group for my Advanced Software Engineering module.",
            "It combines ML-powered speech-to-text, automatic disaster validation and severity prediction so incoming reports can be triaged quickly.",
            "The evacuation-routing engine integrates live traffic, weather and public-transport APIs with ML prediction models, running on a cloud-native AWS architecture with a React front end and a Java / Spring Boot backend."
        ],
        links: [],
        hidden: false
    },
    {
        id: "nasa",
        emoji: "\uD83D\uDE80",
        name: "NASA Data Explorer",
        status: "live",
        short: "A full-stack app to explore NASA's open data APIs \u2014 imagery, Mars rover photos and more.",
        tags: [
            "React",
            "Node.js",
            "Express"
        ],
        body: [
            "NASA Data Explorer is a full-stack web app that makes NASA's public data APIs easy to browse \u2014 astronomy pictures of the day, Mars rover photos and other open datasets.",
            "A React front end talks to a Node.js / Express backend that proxies and caches the NASA APIs, keeping the UI fast and within rate limits."
        ],
        links: [
            {
                label: "Visit Project",
                href: "https://nasa-explorer-frontend-eta.vercel.app",
                type: "external"
            },
            {
                label: "View on GitHub",
                href: "https://github.com/Adityakapse/nasa-data-explorer",
                type: "github"
            }
        ],
        hidden: false
    },
    {
        id: "grader",
        emoji: "\uD83C\uDF93",
        name: "AI Assignment Grader",
        status: "wip",
        short: "My MSc dissertation \u2014 an LLM-based multi-agent system for assessing student code.",
        tags: [
            "Python",
            "LLMs",
            "Multi-Agent"
        ],
        body: [
            "My MSc dissertation: the design and evaluation of an LLM-based multi-agent system for code assessment.",
            "Multiple specialised agents evaluate student algorithm submissions against a rubric, and a statistical framework measures how reliable and consistent those AI-generated grades are across repeated runs."
        ],
        links: [
            {
                label: "View on GitHub",
                href: "https://github.com/Adityakapse/ai_assignment_grader",
                type: "github"
            }
        ],
        hidden: true
    },
    {
        id: "revenue",
        emoji: "\uD83D\uDCB0",
        name: "Revenue Manager Agent",
        status: "wip",
        short: "An agentic-AI assistant for revenue management workflows.",
        tags: [
            "Python",
            "Agentic AI",
            "LLMs"
        ],
        body: [
            "An experimental agentic-AI assistant that automates revenue-management workflows \u2014 pulling data, reasoning over pricing and demand signals, and proposing actions."
        ],
        links: [
            {
                label: "View on GitHub",
                href: "https://github.com/Adityakapse/revenue-manager-agent",
                type: "github"
            }
        ],
        hidden: true
    },
    {
        id: "smartbrain",
        emoji: "\uD83E\uDDE0",
        name: "SmartBrain",
        status: "done",
        short: "A face-detection web app tracking per-user detection counts.",
        tags: [
            "React",
            "Node.js",
            "PostgreSQL"
        ],
        body: [
            "SmartBrain is a face-detection web app with a React front end and a Node.js / Express backend.",
            "Users register, sign in and submit image URLs; the app detects faces and tracks how many detections each user has run against a PostgreSQL database."
        ],
        links: [
            {
                label: "View on GitHub",
                href: "https://github.com/Adityakapse/smartbrain",
                type: "github"
            }
        ],
        hidden: true
    },
    {
        id: "attendance",
        emoji: "\uD83D\uDCF8",
        name: "Face-Recognition Attendance",
        status: "done",
        short: "A HOG + CNN attendance system \u2014 published at the ITM Web of Conferences.",
        tags: [
            "Python",
            "OpenCV",
            "CNN"
        ],
        body: [
            "An automated attendance system that uses HOG features and a CNN for face recognition, captured in real time with OpenCV and matched against an enrolled database.",
            'The work was published as "Face recognition attendance system using HOG and CNN algorithm" in the ITM Web of Conferences (44, 03028, 2022).'
        ],
        links: [
            {
                label: "Read Paper",
                href: "https://doi.org/10.1051/itmconf/20224403028",
                type: "external"
            },
            {
                label: "View on GitHub",
                href: "https://github.com/Adityakapse/Attendance-system",
                type: "github"
            }
        ],
        hidden: true
    },
    {
        id: "christmas",
        emoji: "\uD83C\uDF84",
        name: "Christmas Media Player",
        status: "done",
        short: "A festive, Christmas-themed online media player.",
        tags: [
            "JavaScript",
            "HTML5 Audio"
        ],
        body: [
            "A fun, Christmas-themed online media player \u2014 a small side project built with vanilla JavaScript and the HTML5 audio APIs."
        ],
        links: [
            {
                label: "View on GitHub",
                href: "https://github.com/Adityakapse/christmasmediaplayer",
                type: "github"
            }
        ],
        hidden: true
    }
];


// Shared behaviours used across index.html and project.html
const $958244a8dabbaace$export$61171c632678b12e = "adityakapse0222@gmail.com";
function $958244a8dabbaace$export$a8408b6c5639cab7() {
    const y = new Date().getFullYear();
    document.querySelectorAll("#year, .year-mobile").forEach((el)=>el.textContent = y);
}
function $958244a8dabbaace$export$c4d12dff0a005262() {
    const cursor = document.querySelector(".custom-cursor");
    if (!cursor) return;
    const fine = window.matchMedia("(pointer: fine)").matches;
    if (!fine) return;
    document.documentElement.classList.add("cursor-on");
    window.addEventListener("mousemove", (e)=>{
        cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
    }, {
        passive: true
    });
}
function $958244a8dabbaace$export$5e486e2d091eeb69() {
    const btn = document.getElementById("hamburger");
    const nav = document.getElementById("nav");
    if (!btn || !nav) return;
    btn.addEventListener("click", ()=>nav.classList.toggle("collapsed"));
    nav.querySelectorAll("a").forEach((a)=>a.addEventListener("click", ()=>{
            if (window.innerWidth < 1024) nav.classList.add("collapsed");
        }));
}
function $958244a8dabbaace$export$563cf73d5027cca7() {
    const trigger = document.getElementById("contactEmail");
    const done = document.getElementById("copyDone");
    if (!trigger) return;
    const copy = async (ev)=>{
        ev.preventDefault();
        try {
            await navigator.clipboard.writeText($958244a8dabbaace$export$61171c632678b12e);
        } catch  {
            const t = document.createElement("textarea");
            t.value = $958244a8dabbaace$export$61171c632678b12e;
            document.body.appendChild(t);
            t.select();
            document.execCommand("copy");
            document.body.removeChild(t);
        }
        if (done) {
            done.classList.add("show");
            setTimeout(()=>done.classList.remove("show"), 1400);
        }
    };
    trigger.addEventListener("click", copy);
}


(0, $958244a8dabbaace$export$a8408b6c5639cab7)();
(0, $958244a8dabbaace$export$c4d12dff0a005262)();
(0, $958244a8dabbaace$export$5e486e2d091eeb69)();
(0, $958244a8dabbaace$export$563cf73d5027cca7)();
/* ---------- Render project grid ---------- */ const $35da740d59af89ba$var$grid = document.getElementById("projectsGrid");
const $35da740d59af89ba$var$VISIBLE = 4;
$35da740d59af89ba$var$grid.innerHTML = (0, $8bc5ffe9ceba3d4c$export$39babdfab504f3da).map((p, i)=>{
    const cls = [
        "project-card"
    ];
    if (p.status === "wip") cls.push("wip");
    if (i >= $35da740d59af89ba$var$VISIBLE) cls.push("hidden-project");
    const tags = p.tags.map((t)=>`<span class="tag not-italic">${t}</span>`).join("");
    return `
      <a href="#/project/${p.id}" class="${cls.join(" ")}" data-reveal>
        <div class="card-head">
          <h3 class="card-title"><span class="not-italic">${p.emoji}</span> ${p.name}</h3>
          <span class="status not-italic ${p.status}">${p.status}</span>
        </div>
        <p class="card-desc">${p.short}</p>
        <div class="tags">${tags}</div>
      </a>`;
}).join("");
/* ---------- Reveal cards on scroll ---------- */ const $35da740d59af89ba$var$cards = [
    ...$35da740d59af89ba$var$grid.querySelectorAll(".project-card")
];
const $35da740d59af89ba$var$cardObserver = new IntersectionObserver((entries)=>{
    entries.forEach((e)=>{
        if (e.isIntersecting) {
            e.target.classList.add("active");
            $35da740d59af89ba$var$cardObserver.unobserve(e.target);
        }
    });
}, {
    threshold: 0.15
});
$35da740d59af89ba$var$cards.forEach((c)=>$35da740d59af89ba$var$cardObserver.observe(c));
/* ---------- View All Projects ---------- */ const $35da740d59af89ba$var$container = document.getElementById("projectsContainer");
const $35da740d59af89ba$var$mask = document.getElementById("projectsMask");
const $35da740d59af89ba$var$overlay = document.getElementById("viewAllOverlay");
const $35da740d59af89ba$var$viewAllBtn = document.getElementById("viewAllBtn");
const $35da740d59af89ba$var$hasHidden = (0, $8bc5ffe9ceba3d4c$export$39babdfab504f3da).length > $35da740d59af89ba$var$VISIBLE;
if ($35da740d59af89ba$var$hasHidden) $35da740d59af89ba$var$mask.classList.add("masked");
else $35da740d59af89ba$var$overlay.classList.add("hidden");
$35da740d59af89ba$var$viewAllBtn?.addEventListener("click", ()=>{
    $35da740d59af89ba$var$container.classList.add("expanded");
    $35da740d59af89ba$var$mask.classList.remove("masked");
    $35da740d59af89ba$var$overlay.classList.add("hidden");
    // reveal newly shown cards
    $35da740d59af89ba$var$container.querySelectorAll(".hidden-project").forEach((c)=>c.classList.add("active"));
});
/* ---------- Nav scroll-spy ---------- */ const $35da740d59af89ba$var$navBtns = [
    ...document.querySelectorAll(".nav-btn[data-target]")
];
const $35da740d59af89ba$var$sections = $35da740d59af89ba$var$navBtns.map((b)=>document.getElementById(b.dataset.target)).filter(Boolean);
const $35da740d59af89ba$var$spy = new IntersectionObserver((entries)=>{
    entries.forEach((e)=>{
        if (e.isIntersecting) {
            const id = e.target.id;
            $35da740d59af89ba$var$navBtns.forEach((b)=>b.classList.toggle("active", b.dataset.target === id));
        }
    });
}, {
    rootMargin: "-45% 0px -50% 0px",
    threshold: 0
});
$35da740d59af89ba$var$sections.forEach((s)=>$35da740d59af89ba$var$spy.observe(s));
/* ---------- Experience timeline progress ---------- */ const $35da740d59af89ba$var$timeline = document.querySelector(".timeline");
const $35da740d59af89ba$var$progress = document.getElementById("timelineProgress");
const $35da740d59af89ba$var$dots = [
    ...document.querySelectorAll(".exp-item")
];
function $35da740d59af89ba$var$updateTimeline() {
    if (!$35da740d59af89ba$var$timeline || !$35da740d59af89ba$var$progress) return;
    const rect = $35da740d59af89ba$var$timeline.getBoundingClientRect();
    const vh = window.innerHeight;
    const start = vh * 0.5;
    const filled = Math.min(Math.max(start - rect.top, 0), rect.height);
    $35da740d59af89ba$var$progress.style.height = `${filled / rect.height * 100}%`;
    $35da740d59af89ba$var$dots.forEach((item)=>{
        const r = item.getBoundingClientRect();
        item.classList.toggle("reached", r.top < start);
    });
}
window.addEventListener("scroll", $35da740d59af89ba$var$updateTimeline, {
    passive: true
});
window.addEventListener("resize", $35da740d59af89ba$var$updateTimeline);
$35da740d59af89ba$var$updateTimeline();
/* ---------- Hash router: project detail view ---------- */ const $35da740d59af89ba$var$home = document.getElementById("home");
const $35da740d59af89ba$var$detail = document.getElementById("detail");
const $35da740d59af89ba$var$mobileFooter = document.querySelector(".mobile-footer");
const $35da740d59af89ba$var$ICONS = {
    github: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 .5A11.5 11.5 0 0 0 .5 12a11.5 11.5 0 0 0 7.86 10.92c.58.1.79-.25.79-.56v-2c-3.2.7-3.88-1.54-3.88-1.54-.53-1.34-1.3-1.7-1.3-1.7-1.06-.72.08-.71.08-.71 1.17.08 1.79 1.2 1.79 1.2 1.04 1.79 2.73 1.27 3.4.97.1-.75.4-1.27.73-1.56-2.55-.29-5.24-1.28-5.24-5.69 0-1.26.45-2.29 1.19-3.09-.12-.29-.52-1.46.11-3.05 0 0 .97-.31 3.18 1.18a11 11 0 0 1 5.79 0c2.2-1.49 3.17-1.18 3.17-1.18.63 1.59.23 2.76.11 3.05.74.8 1.19 1.83 1.19 3.09 0 4.42-2.69 5.39-5.25 5.68.41.36.78 1.06.78 2.14v3.17c0 .31.21.67.8.56A11.5 11.5 0 0 0 23.5 12 11.5 11.5 0 0 0 12 .5Z"/></svg>',
    external: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><path d="M15 3h6v6M10 14 21 3"/></svg>'
};
function $35da740d59af89ba$var$renderDetail(project) {
    const tags = project.tags.map((t)=>`<span class="tag not-italic">${t}</span>`).join("");
    const body = project.body.map((p)=>`<p>${p}</p>`).join("");
    const actions = project.links.map((l)=>`<a class="detail-btn" href="${l.href}" target="_blank" rel="noopener noreferrer">${$35da740d59af89ba$var$ICONS[l.type] || ""}<span>${l.label}</span></a>`).join("");
    $35da740d59af89ba$var$detail.innerHTML = `
    <div class="detail-head">
      <h1 class="detail-title"><span class="not-italic">${project.emoji}</span> ${project.name}</h1>
      <span class="status not-italic ${project.status}">${project.status}</span>
    </div>
    <div class="detail-tags">${tags}</div>
    <div class="detail-body">${body}</div>
    ${actions ? `<div class="detail-actions">${actions}</div>` : ""}
    <a href="#projects" class="back-link">\u{2190} Back to all projects</a>`;
}
function $35da740d59af89ba$var$router() {
    const m = location.hash.match(/^#\/project\/(.+)$/);
    const project = m && (0, $8bc5ffe9ceba3d4c$export$39babdfab504f3da).find((p)=>p.id === m[1]);
    if (project) {
        $35da740d59af89ba$var$renderDetail(project);
        $35da740d59af89ba$var$detail.hidden = false;
        $35da740d59af89ba$var$home.hidden = true;
        if ($35da740d59af89ba$var$mobileFooter) $35da740d59af89ba$var$mobileFooter.hidden = true;
        document.title = `${project.name} \xb7 Aditya Kapse`;
        window.scrollTo(0, 0);
    } else {
        $35da740d59af89ba$var$detail.hidden = true;
        $35da740d59af89ba$var$home.hidden = false;
        if ($35da740d59af89ba$var$mobileFooter) $35da740d59af89ba$var$mobileFooter.hidden = false;
        document.title = "Aditya Kapse";
    }
}
window.addEventListener("hashchange", $35da740d59af89ba$var$router);
$35da740d59af89ba$var$router();


//# sourceMappingURL=index.96dc6d72.js.map
